module.exports = __webpack_public_path__ + "50562a03f1893b756390856d3e382af1.svg";